import { useEffect, useState } from 'react';
import { useLocale } from '../context';
import {
  ensureNetworkNoticesReady,
  isNetworkNoticesReady,
  NETWORK_NOTICES_READY_EVENT,
} from './loading/dismissAppBoot';
import './network-notice.css';

const EVENT = 'vb:api-reconnect';

export default function ApiReconnectNotice() {
  const { t } = useLocale();
  const [active, setActive] = useState(false);
  const [ready, setReady] = useState(() => isNetworkNoticesReady());

  useEffect(() => {
    const onEvent = (e) => {
      setActive(Boolean(e?.detail?.active));
    };
    window.addEventListener(EVENT, onEvent);
    return () => window.removeEventListener(EVENT, onEvent);
  }, []);

  useEffect(() => {
    if (ready) return undefined;
    const mark = () => {
      ensureNetworkNoticesReady();
      if (isNetworkNoticesReady()) setReady(true);
    };
    window.addEventListener(NETWORK_NOTICES_READY_EVENT, mark);
    const poll = window.setInterval(mark, 250);
    mark();
    return () => {
      window.removeEventListener(NETWORK_NOTICES_READY_EVENT, mark);
      window.clearInterval(poll);
    };
  }, [ready]);

  if (!ready || !active) return null;

  return (
    <div className="tb--notice-wrapper vb-network-notice vb-api-reconnect" aria-live="polite" role="status">
      <div className="tb--notice-container">
        <div className="tb--notice-content tb--notice-network_poor tb--flex tb--justify-between tb--align-center">
          <div className="tb--flex tb--align-center">
            <span className="vb-net-icon vb-net-icon--poor vb-api-reconnect__spin-wrap" aria-hidden="true">
              <span className="vb-net-icon__halo" />
              <span className="vb-net-icon__core vb-api-reconnect__spin">
                <svg className="vb-net-icon__svg" viewBox="0 0 24 24" focusable="false">
                  <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
              </span>
            </span>
            <span className="tb--notice-msg">{t('network.reconnecting')}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
